module.exports = __webpack_public_path__ + "static/media/solution_banner_4_cp.2a808b73.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/solution_banner_4_cp.png
// module id = 582
// module chunks = 0